import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 border-t border-background-300 bg-secondary-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="mb-12 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-background-50">
                爆
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{siteInfo.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">{siteInfo.slogan}</p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{siteInfo.tagline}</p>
            <div className="mt-5 flex items-center gap-2">
              {siteInfo.socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  rel="nofollow"
                  aria-label={s.label}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-secondary-300 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className={`${s.icon} text-base`} />
                  </span>
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="站内导航">
            <h2 className="font-heading text-base font-bold text-foreground-950">站内导航</h2>
            <ul className="mt-4 flex flex-col gap-2.5">
              {siteInfo.nav.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="cursor-pointer text-sm text-foreground-700 transition-colors hover:text-primary-700">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="内容频道">
            <h2 className="font-heading text-base font-bold text-foreground-950">内容频道</h2>
            <ul className="mt-4 grid grid-cols-2 gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="cursor-pointer text-sm text-foreground-700 transition-colors hover:text-primary-700"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="font-heading text-base font-bold text-foreground-950">线索与联系</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              手里有正在发生的一手信息？欢迎把时间、地点和可核实细节发给我们。
            </p>
            <p className="mt-3 flex items-center gap-2 text-sm text-foreground-800">
              <span className="flex h-4 w-4 items-center justify-center text-primary-600">
                <i className="ri-mail-line text-base" />
              </span>
              {siteInfo.email}
            </p>
            <Link
              to="/contact"
              className="mt-5 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-send-plane-line text-sm" />
              </span>
              提交线索
            </Link>
          </div>
        </div>

        <div className="flex flex-col gap-3 border-t border-secondary-300 pt-6 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteInfo.name} · 实时热点追踪与突发新闻速递</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>爆料平台</span>
            <span>实时热点</span>
            <span>突发新闻</span>
            <span>全网热搜</span>
          </p>
        </div>
      </div>
    </footer>
  );
}